import { render, staticRenderFns } from "./help.vue?vue&type=template&id=08b18d82&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=08b18d82&prod&lang=scss"
import style1 from "./help.vue?vue&type=style&index=1&id=08b18d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b18d82",
  null
  
)

export default component.exports